import { takeLatest } from "redux-saga/effects";
import { FINALIZE_PACKAGE } from "../actions/constants";
import finalizePackageSaga from "./finalizePackageSaga";

export function* watchFinalizePackage() {
  yield takeLatest(FINALIZE_PACKAGE, finalizePackageSaga);
}
